import type { MarketingModalAction } from './events';
import { contest } from '$lib/constants/contest';
import { track } from '$lib/services/tracking/googleAnalytics';
import { booleanToString } from './tracking';

export const marketingModalActions: Record<string, MarketingModalAction> = {
	display: 'display',
	click: 'click',
	close: 'close',
};

const marketingModalContext = contest.tracking.context;

export function trackMarketingModal(action: MarketingModalAction, count: number) {
	track({
		action: 'contest_interstitial',
		payload: {
			action,
			context: marketingModalContext,
			modal_display_count: count + 1,
			modal_is_first_display: booleanToString(count === 0),
		},
	});
}
